import { useState } from 'react';
import { EyeOutlined, ConsoleSqlOutlined, DesktopOutlined, FileTextOutlined, FormOutlined, LinkOutlined, LogoutOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { ItemType } from 'antd/es/menu/interface';
import { logoutAction } from '../redux/actions/auth';
import { useDispatch } from 'react-redux';
const { Sider } = Layout;

export interface DataItem {
    id: number;
    name: string;
}

export interface SideBarModel {
    parent: SideBarItem;
    children?: SideBarItem[];
}

export interface SideBarItem {
    key: string;
    icon: any;
    label: string;
    requiredUserType?: number;
}

const MenuItem: SideBarModel[] = [
    {
        parent: {
            key: "/cms/home",
            icon: <DesktopOutlined />,
            label: 'Anasayfa',
        }
    },
    {
        parent: {
            key: "/cms/posts",
            icon: <FileTextOutlined />,
            label: 'Blog',
        }
    },
    {
        parent: {
            key: "/cms/categories",
            icon: <LinkOutlined />,
            label: 'Kategoriler',
        }
    },
    {
        parent: {
            key: "/cms/products",
            icon: <ConsoleSqlOutlined />,
            label: 'Ürünler',
        }
    },
    {
        parent: {
            key: "/cms/newsletter",
            icon: <MailOutlined />,
            label: 'E-Bülten Listesi',
        }
    },
    {
        parent: {
            key: "/cms/contact-form",
            icon: <FormOutlined />,
            label: 'İletişim Formu',
        }
    },
    {
        parent: {
            key: "/cms/site-settings",
            icon: <SettingOutlined />,
            label: 'Site Ayarları'
        }
    },
    {
        parent: {
            key: "logout",
            icon: <LogoutOutlined />,
            label: 'Çıkış',
        }
    }
];

const SideBar = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { pathname } = location;

    const authData = JSON.parse(localStorage.getItem("auth") || "{}");

    const items: ItemType[] = MenuItem.map((menuItem) => ({
        key: menuItem.parent.key,
        icon: menuItem.parent.icon,
        label: menuItem.parent.label,
        children: menuItem.children?.map((childItem) => ({
            key: childItem.key,
            icon: childItem.icon,
            label: childItem.label,
        })),
    }));

    const handleMenuSelect = (info: any) => {
        if (info.key === "logout") {
            dispatch<any>(logoutAction());
        navigate("/auth");
        } else {
            navigate(`${info.key}`);
        }
    };

    const [collapsed, setCollapsed] = useState(false);

    let sidebar = (
        <Sider collapsible collapsed={collapsed} onCollapse={(value: any) => setCollapsed(value)} width={300}>
            <div className="flex p-4">
                <img src="/images/logo.png" alt="logo" className='w-52' />
            </div>
            <div className='flex flex-wrap text-white font-bold text-2xl cursor-pointer ml-6 my-3 border-b border-green-900 pb-4 overflow-hidden text-ellipsis'>{"Hoşgeldin " + authData?.user?.username.toLocaleUpperCase()}</div>
            <div className='flex flex-wrap text-white font-bold text-base cursor-pointer ml-6 my-3 border-b border-green-900 pb-4 overflow-hidden text-ellipsis'><a href='/' target='_blank' rel='noopener noreferrer'><EyeOutlined /> Siteyi Görüntüle</a></div>
            <Menu
                theme="dark"
                defaultSelectedKeys={['home']}
                selectedKeys={pathname ? [pathname] : []}
                defaultOpenKeys={['#', '/statisticsPage']}
                mode="inline"
                items={items}
                onSelect={handleMenuSelect}
            />
            {!collapsed && (
                <div className="custom-sider-footer">
                    © 2025 Tüpraş
                </div>
            )}
        </Sider>
    );

    return sidebar;
};

export default SideBar;